// extracted by mini-css-extract-plugin
export default {"modalOverlay":"sJ-z","modalContent":"tJ-z","header":"uJ-z","close":"vJ-z"};